// borrowed from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file
export function formatFileSize(bytes: number) {
  if (bytes < 1e3) {
    return `${bytes} bytes`;
  } else if (bytes >= 1e3 && bytes < 1e6) {
    return `${(bytes / 1e3).toFixed(1)} KB`;
  } else {
    return `${(bytes / 1e6).toFixed(1)} MB`;
  }
}
